module.exports = __webpack_public_path__ + "img/drogsan_logo.2f809a40.png";